import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Input, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";

const auth = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

// Catálogo de solo nombres, activables. props: titulo, subtitulo, icono, url
export default function CatalogoSimple({ titulo, subtitulo, icono, url }) {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState(null); // { name } o revalidador en edición

  const carga = () =>
    axios
      .get(url, { headers: auth() })
      .then(({ data }) => setLista(Array.isArray(data) ? data : []))
      .catch(() => setLista([]));
  useEffect(() => { carga(); }, []);

  const guardar = async () => {
    if (!form.name.trim()) return Swal.fire({ icon: "warning", title: t("Captura el nombre") });
    try {
      if (form._id) await axios.patch(`${url}/${form._id}`, { name: form.name }, { headers: auth() });
      else await axios.post(url, { name: form.name }, { headers: auth() });
      setForm(null);
      carga();
      Swal.fire({ toast: true, position: "top-end", icon: "success", title: t("Guardado"), showConfirmButton: false, timer: 1400 });
    } catch (err) {
      Swal.fire({ icon: "error", title: t("No se pudo guardar"), text: err?.response?.data?.message || err.message });
    }
  };

  const activa = async (r) => {
    const is_active = r.is_active === "Si" ? "No" : "Si";
    await axios.patch(`${url}/${r._id}`, { is_active }, { headers: auth() });
    setLista((rs) => rs.map((x) => (x._id === r._id ? { ...x, is_active } : x)));
  };

  if (!user.menuNavieras) return <Header />;

  return (
    <>
      <Header />
      <div className="container col-sm-11">
        <div className="page-header">
          <div>
            <h3 className="page-title">
              <span className="page-title-icon"><i className={icono} /></span>
              {t(titulo)}
            </h3>
            <p className="page-subtitle">{t(subtitulo)}</p>
          </div>
          <div className="page-actions">
            <Button size="sm" color="success" onClick={() => setForm({ name: "" })}><i className="fas fa-plus" /> {t("Nuevo")}</Button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <Table size="sm" hover className="table-responsive-xl">
              <thead>
                <tr><th>{t("Nombre")}</th><th>{t("Activo")}</th><th></th></tr>
              </thead>
              <tbody>
                {lista.map((r) => (
                  <tr key={r._id} className={r.is_active === "No" ? "td-muted" : undefined}>
                    <td className="td-strong">{r.name}</td>
                    <td>
                      <button type="button" className={`badge-soft badge-soft-${r.is_active === "No" ? "secondary" : "success"} rv-badge-btn`} onClick={() => activa(r)}>
                        {r.is_active === "No" ? "No" : t("Si")}
                      </button>
                    </td>
                    <td>
                      <Button size="sm" color="info" onClick={() => setForm({ ...r })}><i className="far fa-edit" /></Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {lista.length === 0 ? <div className="td-muted">{t("Sin registros")}</div> : null}
          </div>
        </div>
      </div>

      <Modal isOpen={!!form} toggle={() => setForm(null)}>
        <ModalHeader toggle={() => setForm(null)}>{form && form._id ? t("Editar") : t("Nuevo")}</ModalHeader>
        <ModalBody>
          {form ? (
            <>
              <Label>{t("Nombre")}</Label>
              <Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} />
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}><i className="fas fa-save" /> {t("Guardar")}</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
